import { render, staticRenderFns } from "./assignments-rams.vue?vue&type=template&id=49ab579c"
import script from "./assignments-rams.vue?vue&type=script&lang=js"
export * from "./assignments-rams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports